import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { GeneralForm } from './GeneralForm';

@inject('store')
@observer
export class SettingsView extends Component {
    render() {
        return (
            <div>
                <GeneralForm data={this.props.store.makoBotStore.config} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/SettingsView/index.js